import React, { useState } from "react";
import { ModalXoa } from "./ModalXoa";

export const BtnXoa = ({ item, onReload }) => {
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const handleDeleted = () => {
		setShow(false);
		if (onReload) onReload();
	};
	return (
		<>
			<a type="button" className="popover-basic" onClick={handleShow}>
				<img src="/app-assets/images/icon-xoa-v2.png" title="Xóa" />
			</a>
			{show && (
				<ModalXoa show={show} onHide={handleClose} item={item} onDeleted={handleDeleted} />
			)}
		</>
	);
};
